import type { FC } from 'react'
import classNames from 'classnames'

import { Text } from 'components'
import {
  FooterLogoDark,
  FacebookIcon,
  Copyright,
  InstagramIcon,
  TelegramIcons,
  MessageIcon,
  PhoneIcon,
} from 'assets'

import styles from './Footer.module.scss'

const Footer: FC = () => (
  <footer className={styles.container}>
    <div className={classNames(styles.footer, 'container')}>
      <div className={styles.footer__top}>
        <div className={styles.footer__col}>
          <div className={styles.footer__heading}>
            <Text text='information' className={styles.footer__title} />
            <span className={styles.footer__accent} aria-hidden />
          </div>
          <Text text={'informationText'} className={styles.footer__description} />
        </div>

        <div className={styles.footer__center}>
          <div className={styles.footer__logoWrap}>
            <img src={FooterLogoDark} alt='Engineering Group' className={styles.footer__logo} />
          </div>
          <div className={styles.footer__socials} aria-hidden>
            <span className={styles.footer__social}>
              <FacebookIcon />
            </span>
            <span className={styles.footer__social}>
              <InstagramIcon />
            </span>
            <span className={styles.footer__social}>
              <TelegramIcons />
            </span>
          </div>
        </div>

        <div className={styles.footer__col}>
          <div className={styles.footer__heading}>
            <Text text='contact' className={styles.footer__title} />
            <span className={styles.footer__accent} aria-hidden />
          </div>
          <Text text={'contactText'} className={styles.footer__description} />

          <div className={styles.footer__contacts}>
            <a href='mailto:info@engineeringgroup.am' className={styles.footer__contact}>
              <span className={styles.footer__contact_icon}>
                <MessageIcon />
              </span>
              info@engineeringgroup.am
            </a>
            <a href='tel:+37444144199' className={styles.footer__contact}>
              <span className={styles.footer__contact_icon}>
                <PhoneIcon />
              </span>
              +374 44 144 199
            </a>
          </div>
        </div>
      </div>

      <div className={styles.footer__divider} />

      <p className={styles.footer__copyright}>
        <Copyright /> www.engineeringgroup.am · www.e-group.am
      </p>
    </div>
  </footer>
)

export default Footer
